import { X, LogOut } from "lucide-react";
import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";

export default function Sidebar(props: any) {
  const [isActive, setIsActive] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);

  const navigate = useNavigate();
  const location = useLocation();
  const isNewUserPage = location.pathname === "/newuser";

  const handleLogout = () => {
    localStorage.clear();
    window.location.href = "/";
  };
  const onQuestionnaireClick = () => {
    const agentId = localStorage.getItem("NowcertsAgentId");
    if (agentId) {
      navigate("/agencyinfo");
    } else {
      navigate("/scale");
    }
  };
  const onSimulatorClick = () => navigate("/simulator");
  const onHistoryClick = () => navigate("/history");

  const openLink = () => {
    window.open(process.env.REACT_APP_Schedule_Appointment_Url, "_blank");
  };

  const menuItems = [
    { label: "Diagnostic Assessment", icon: "📋", onClick: onQuestionnaireClick, activePages: ["agency-information", "question", "summary"] },
    { label: "Agency Simulator", icon: "🔧", onClick: onSimulatorClick, activePages: ["simulator"] },
    { label: "Benchmarking", icon: "📊", onClick: openLink, activePages: [""] },
    { label: "Thought Leadership", icon: "💡", onClick: openLink, activePages: [""] },
    { label: "MAPS Solutions", icon: "🚀", onClick: openLink, activePages: [""] },
    { label: "AI Innovation Lab", icon: "🔬", onClick: openLink, activePages: [""] },
    { label: "AI Insights Survey", icon: "📈", onClick: openLink, activePages: [""] },
    { label: "MAPS Cockpit Channel", icon: "🎛️", onClick: openLink, activePages: [""] },
    { label: "Momentum Connect", icon: "🌐", onClick: openLink, activePages: [""] },
    { label: "History", icon: "🕐", onClick: onHistoryClick, activePages: ["history"] },
  ];

  return (
    <>
      {props.sidebarOpen && <div className="fixed inset-0 z-30 bg-black bg-opacity-40 md:hidden" onClick={props.onSidebarClick} />}

      {/* Sidebar */}
      <aside
        className={`fixed top-0 h-screen z-40 inset-y-0 left-0 w-64 bg-white shadow-md transform transition-transform duration-300 md:relative md:translate-x-0 ${
          props.sidebarOpen ? "translate-x-0" : "-translate-x-full"
        }`}
      >
        <div className="h-full flex flex-col justify-between">
          {/* Top Section */}
          <div className="py-4 px-1">
            <div className="text-xl font-bold text-green-600 mb-6 flex items-center justify-between">
              <div className="flex items-center space-x-2">
                <div className="h-12">
                  <svg className="h-full w-auto max-w-[180px]" viewBox="0 0 450 80" xmlns="http://www.w3.org/2000/svg">
                    <g>
                      <path d="M20 50 L40 40 L45 45 L45 70 L40 75 L20 65 Z" fill="#5BD584" />
                      <path d="M55 35 L75 25 L80 30 L80 70 L75 75 L55 65 Z" fill="#5BD584" />
                      <path d="M90 20 L110 10 L115 15 L115 70 L110 75 L90 65 Z" fill="#5BD584" />
                    </g>
                    <text x="135" y="45" fontFamily="Arial, sans-serif" fontSize="42" fontWeight="500" fill="#000000">
                      momentum
                    </text>
                    <text x="135" y="70" fontFamily="Arial, sans-serif" fontSize="32" fontWeight="400" fill="#5BD584">
                      maps
                    </text>
                  </svg>
                </div>
              </div>

              {!isNewUserPage && (
                <button className="md:hidden" onClick={props.onSidebarClick}>
                  <X className="w-6 h-6 text-gray-700" />
                </button>
              )}
            </div>

            {/* Navigation */}
            {!isNewUserPage && (
              <nav className="bg-white flex flex-col">
                <div className="flex-1 px-2 py-4 space-y-1">
                  {menuItems.map((item, index) => {
                    const isActive = item.activePages.includes(props.pagename);
                    return (
                      <button
                        key={index}
                        onClick={item.onClick}
                        className={`w-full flex items-center gap-3 px-4 py-2 text-sm rounded-md transition
                          ${isActive ? "bg-green-100 text-green-700" : "text-gray-700 hover:bg-gray-100"}`}
                      >
                        <span className="text-lg">{item.icon}</span>
                        {item.label}
                      </button>
                    );
                  })}
                </div>
              </nav>
            )}
          </div>

          {/* Logout Button */}
          {!isNewUserPage && (
            <div className="p-4 border-t">
              <button onClick={handleLogout} className="flex items-center space-x-2 text-red-600">
                <LogOut className="w-5 h-5" />
                <span>Logout</span>
              </button>
            </div>
          )}
        </div>
      </aside>
    </>
  );
}
